/* ==========================================================================
   KineticStrap — theme interactions
   Vanilla, dependency-free. Progressive enhancement: every feature degrades
   gracefully if JS is off. Respects prefers-reduced-motion.
   Modules: reveals · nav · counters · before/after slider · color swatches
            · reviews marquee · mobile menu · newsletter form
   ========================================================================== */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $  = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  function init() {
    initReveals();
    initNav();
    initCounters();
    initSlider();
    initColor();
    initMarquee();
    initBurger();
    initForm();
  }

  /* --------------------------------------------------------------- Reveals */
  function initReveals() {
    var items = $$('.ks-reveal');
    if (reduced || !('IntersectionObserver' in window)) {
      items.forEach(function (e) { e.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        el.style.transitionDelay = (parseFloat(el.dataset.delay || 0)) + 'ms';
        el.classList.add('is-visible');
        io.unobserve(el);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    items.forEach(function (e) { io.observe(e); });
  }

  /* ------------------------------------------------------- Sticky nav + hero */
  function initNav() {
    // Header has no scroll effect (it is always solid). We only keep a light
    // parallax on the hero image, and only when a hero is present.
    var hero = $('[data-ks-hero]');
    if (reduced || !hero) return;
    var onScroll = function () {
      var y = window.scrollY || window.pageYOffset;
      hero.style.transform = 'translate3d(0,' + (y * 0.22) + 'px,0) scale(1.12)';
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* -------------------------------------------------------------- Counters */
  function initCounters() {
    var stats = $$('[data-count]');
    if (!stats.length) return;
    var run = function (el) {
      var target = parseFloat(el.dataset.count);
      var pre = el.dataset.pre || '';
      var suf = el.dataset.suf || '';
      if (reduced) { el.textContent = pre + target.toLocaleString() + suf; return; }
      var dur = 1300, t0 = performance.now();
      var step = function (t) {
        var k = Math.min(1, (t - t0) / dur);
        k = 1 - Math.pow(1 - k, 3);
        el.textContent = pre + Math.round(target * k).toLocaleString() + suf;
        if (k < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    };
    if (!('IntersectionObserver' in window)) { stats.forEach(run); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { run(en.target); io.unobserve(en.target); }
      });
    }, { threshold: 0.6 });
    stats.forEach(function (s) { io.observe(s); });
  }

  /* ----------------------------------------------------- Before/after slider */
  function initSlider() {
    var box = $('[data-ba]');
    if (!box) return;
    var handle      = $('.ks-ba__handle', box);
    var lblWithout  = $('.ks-ba__label--without', box);
    var lblWith     = $('.ks-ba__label--with', box);
    var cap         = $('.ks-ba__caption');
    var CAP_WITHOUT = box.dataset.capWithout || 'Every stride sends full impact force straight through the tendon.';
    var CAP_WITH    = box.dataset.capWith    || 'The strap absorbs and redistributes the load — the tendon stays protected.';

    var target = 50, cur = 50, raf = null;

    function render() {
      box.style.setProperty('--split', cur);
      if (lblWithout) lblWithout.style.opacity = Math.max(0.12, Math.min(1, cur / 46));
      if (lblWith)    lblWith.style.opacity    = Math.max(0.12, Math.min(1, (100 - cur) / 46));
      if (handle)     handle.setAttribute('aria-valuenow', Math.round(cur));
      if (cap) {
        var t = cur > 50 ? CAP_WITHOUT : CAP_WITH;
        if (cap.dataset.t !== t) {
          cap.dataset.t = t; cap.textContent = t;
          cap.style.color = cur > 50 ? 'var(--heat)' : 'var(--accent)';
        }
      }
    }
    function loop() {
      cur += (target - cur) * 0.2;
      if (Math.abs(target - cur) < 0.3) { cur = target; render(); raf = null; return; }
      render();
      raf = requestAnimationFrame(loop);
    }
    function setTarget(p, instant) {
      target = Math.max(0, Math.min(100, p));
      if (instant || reduced) { cur = target; render(); return; }
      if (!raf) raf = requestAnimationFrame(loop);
    }
    setTarget(50, true);

    function pos(e) {
      var r = box.getBoundingClientRect();
      var cx = (e.touches ? e.touches[0].clientX : e.clientX) - r.left;
      return cx / r.width * 100;
    }
    var dragging = false;
    box.addEventListener('pointerdown', function (e) {
      dragging = true;
      if (box.setPointerCapture) box.setPointerCapture(e.pointerId);
      setTarget(pos(e));
    });
    box.addEventListener('pointermove', function (e) { if (dragging) setTarget(pos(e)); });
    window.addEventListener('pointerup', function () { dragging = false; });

    if (handle) {
      handle.addEventListener('keydown', function (e) {
        var d = 0;
        if (e.key === 'ArrowLeft')  d = -(e.shiftKey ? 10 : 4);
        else if (e.key === 'ArrowRight') d = (e.shiftKey ? 10 : 4);
        else if (e.key === 'Home') { e.preventDefault(); return setTarget(0); }
        else if (e.key === 'End')  { e.preventDefault(); return setTarget(100); }
        if (d) { e.preventDefault(); setTarget(target + d); }
      });
    }

    // one-time attention nudge when the widget scrolls into view
    if (!reduced && 'IntersectionObserver' in window) {
      var done = false;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting && !done) {
            done = true;
            setTimeout(function () { setTarget(28); }, 480);
            setTimeout(function () { setTarget(74); }, 1150);
            setTimeout(function () { setTarget(50); }, 1900);
          }
        });
      }, { threshold: 0.45 });
      io.observe(box);
    }
  }

  /* --------------------------------------------------------- Color swatches */
  function initColor() {
    var host     = $('[data-ks-prodimg]');
    var main     = host ? (host.tagName === 'IMG' ? host : host.querySelector('img')) : null;
    var label    = $('[data-ks-colorname]');
    var priceEl  = $('.ks-price__amount');
    var variantField = $('[data-ks-variant-field]');
    var swatches = $$('[data-swatch]');
    if (!swatches.length) return;

    function select(s, animate) {
      swatches.forEach(function (o) { o.classList.remove('is-active'); o.setAttribute('aria-checked', 'false'); });
      s.classList.add('is-active');
      s.setAttribute('aria-checked', 'true');
      if (label) label.textContent = s.dataset.name;
      if (main && s.dataset.img) {
        if (animate) {
          main.style.opacity = 0;
          setTimeout(function () { main.src = s.dataset.img; main.style.opacity = 1; }, 170);
        } else {
          main.src = s.dataset.img;
        }
      }
      // When a real product is linked, keep add-to-cart + price in sync with the colour.
      if (variantField && s.dataset.variantId) variantField.value = s.dataset.variantId;
      if (priceEl && s.dataset.price) priceEl.textContent = s.dataset.price;
    }
    swatches.forEach(function (s) { s.addEventListener('click', function () { select(s, true); }); });
    var start = swatches.filter(function (s) { return s.dataset.default === 'true'; })[0] || swatches[0];
    select(start, false);
  }

  /* -------------------------------------------------------- Reviews marquee */
  function initMarquee() {
    var track = $('.ks-marquee__track');
    if (!track) return;
    track.innerHTML += track.innerHTML;      // duplicate for a seamless loop
    if (reduced) track.style.animation = 'none';
  }

  /* ------------------------------------------------------------ Mobile menu */
  function initBurger() {
    var burger = $('[data-ks-burger]');
    var panel  = $('.ks-mobile');
    if (!burger || !panel) return;
    var open = false;
    var setOpen = function (state) {
      open = state;
      panel.style.display = open ? 'flex' : 'none';
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    };
    burger.addEventListener('click', function () { setOpen(!open); });
    $$('.ks-mobile__link', panel).forEach(function (a) {
      a.addEventListener('click', function () { setOpen(false); });
    });
    window.addEventListener('resize', function () { if (window.innerWidth >= 900) setOpen(false); });
  }

  /* -------------------------------------------------------- Newsletter form */
  function initForm() {
    var form  = $('[data-ks-form]');
    if (!form) return;
    var email = $('[data-ks-email]', form);
    var msg   = $('[data-ks-formmsg]');
    // If the form posts to Shopify's customer endpoint, let it submit normally.
    if (form.getAttribute('action')) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = (email && email.value || '').trim();
      var ok = /.+@.+\..+/.test(v);
      if (msg) msg.textContent = ok ? '✓ You’re on the list.' : 'Enter a valid email.';
      if (ok && email) email.value = '';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
